import React, { useState, useEffect } from "react";
import "./DrawerOverlay.scss";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";

import { withRouter } from "react-router-dom";
import PhaseCalculation from '../Phase/phaseCalculationUtil';
import ResourceEdit from "../resource/ResourceEdit";

const EditVendor = (props) => {
  const { resource = {}, estimate = {}, updateResourceFn, refreshData, onClose } = props;
  const [cost, setCost] = useState(0);
  const [updateCnt, setUpdateCnt] = useState(0);

  useEffect(() => {
    const phaseCalculationCls = new PhaseCalculation(
      {},
      {},
      estimate
    );
    const costVal = phaseCalculationCls.resourceCalculate(resource, 'cost', false);
    setCost(costVal)
  }, [estimate]);
  const [updateData, setUpdateData] = useState({})

  return (
    <div id="duplicate" className="side-item">
      <div className="title">
        <h5>
          Update Vendor Cost
          <div className="cross" onClick={props.onClose}>
            <CloseIcon htmlColor="#084d4f" />
          </div>
        </h5>
      </div>
      <div className="content">
        <p>
          Are you sure you want to duplicate the estimates ‘{estimate.projectName}’?
        </p>
        <p>We recommend you rename the estimates.</p>
      </div>
      <div className="input-wrap">
        <div className="d_input">
          <ResourceEdit
            editable={resource.type === 'Vendor'}
            resource={resource}
            updateResource={(updateData) => setUpdateData(updateData, resource)}
            value={cost}
            max={100000}
            refresh={() => { setUpdateCnt(updateCnt + 1) }}
            field='cost'
            fieldKey={resource.resourceId + 'cost'}
            isFocused={true}
          />
        </div>
        <Button
          onClick={() => {
            updateResourceFn(updateData, resource);
            refreshData();
            onClose();
          }}
          variant="contained"
          type="button"
          className="duplicate apply"
        >
          Update
        </Button>
      </div>
    </div>
  );
};

export default withRouter(EditVendor);
